/**
 * Tiny presentational atoms shared by every CampaignBuilder step.
 * Keeping them in a dedicated module both shrinks the parent file and
 * lets each step import only what it needs.
 */
export function Field({ label, hint, children }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.2em] font-bold mb-2">{label}</label>
      {hint && (
        <div className="text-[11px] font-mono text-[var(--rl-text-secondary)] mb-2 -mt-1">
          {hint}
        </div>
      )}
      {children}
    </div>
  );
}

export function ReviewRow({ label, value }) {
  return (
    <div className="flex items-start justify-between gap-4 py-3 border-b border-[var(--rl-border)] last:border-0">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--rl-text-secondary)]">{label}</div>
      <div className="text-sm font-semibold text-right max-w-md">{value || "—"}</div>
    </div>
  );
}

export function Row({ label, value, testid }) {
  return (
    <div className="flex items-baseline justify-between gap-4" data-testid={testid}>
      <div className="text-sm text-[var(--rl-text-secondary)]">{label}</div>
      <div className="text-sm font-mono font-semibold">{value}</div>
    </div>
  );
}
